import { useContext } from 'react';
import TranslationsContext from '../contexts/TranslationsContext';

const useTranslate = () => useContext(TranslationsContext)?.translate!;

export default useTranslate;
